global.TABLE_FIXED_CELL_WIDTH = 100
global.TABLE_ROW_HEIGHT = 45
global.SIDE_BAR_SMALL_WIDTH = 80
global.SIDE_BAR_NORMAL_WIDTH = 256
global.TABLE_EXTRA_COLS = 400
global.EXTRA_ROWS = 2
global.NAME_MAX_LENGTH = 75
global.LONG_NAME_MAX_LENGTH = 200
global.TABLE_STATUS_WIDTH = 50
